/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AccessRightsProfile} from '../models/AccessRightsProfile';
import type {Error} from '../models/Error';

export interface GetAdminActiveProfile$Request {
    adminId: number;
}

export interface GetAdminActiveProfile$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAdminActiveProfileRequest = createAction<PayloadData<void, GetAdminActiveProfile$Request>>('GET_ADMIN_ACTIVE_PROFILE__GET_ADMIN_ACTIVE_PROFILE__REQUEST');
export const getAdminActiveProfileSuccess = createAction<PayloadData<AccessRightsProfile, GetAdminActiveProfile$Request>>('GET_ADMIN_ACTIVE_PROFILE__GET_ADMIN_ACTIVE_PROFILE__SUCCESS');
export const getAdminActiveProfileFailure = createAction<PayloadData<Error, GetAdminActiveProfile$Request, true>>('GET_ADMIN_ACTIVE_PROFILE__GET_ADMIN_ACTIVE_PROFILE__FAILURE');

export const getAdminActiveProfileActions = [
    getAdminActiveProfileRequest,
    getAdminActiveProfileSuccess,
    getAdminActiveProfileFailure
] as const;

/**
 * @param {number} meta.adminId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAdminActiveProfile = (meta: GetAdminActiveProfile$Request, config?: GetAdminActiveProfile$Config) => {
    return {
        CALL_API: {
            types: getAdminActiveProfileActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/admins/${meta.adminId}/profiles`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

